// API client — Transitions mandat (Lot M2).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "POST", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const detail = data?.detail;
    const code = typeof detail === "object" ? detail?.code : undefined;
    const msg = typeof detail === "string" ? detail
             : detail?.message || code || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.code = code;
    err.detail = detail;
    throw err;
  }
  return data;
}

const PATH_BY_KEY = {
  sign:                             "sign",
  mark_ready:                       "mark-ready",
  start_commercialization:          "start-commercialization",
  withdraw_from_commercialization:  "withdraw-from-commercialization",
};

export const mandateTransitions = {
  apply: (mandateId, transitionKey) => {
    const path = PATH_BY_KEY[transitionKey];
    if (!path) throw new Error(`Transition inconnue: ${transitionKey}`);
    return req(`/api/mandates/${mandateId}/transitions/${path}`);
  },
  close: (mandateId, { reason, comment }) =>
    req(`/api/mandates/${mandateId}/transitions/close`, {
      body: { reason, comment: comment || null },
    }),
  audit: (mandateId) =>
    req(`/api/mandates/${mandateId}/audit`, { method: "GET" }),
};

export default mandateTransitions;
